import { BetrokkenTrein, BusEvacuatie } from "@/entities/betrokken-treinen";
import { BusEvacuatieNewEditDialog } from "@/features/betrokken-treinen/components/evacuatie-bus/bus-evacuatie-new-edit-dialog";
import { ActionsDropdown, Button, DropdownMenuItem } from "@/shared/components";
import { useState } from "react";
import { BusEvacuatieAfronden } from "./bus-evacuatie-afronden";
import { BusEvacuatieIntrekken } from "./bus-evacuatie-intrekken";

type BusEvacutatieActionsProps = {
    dossierId: string;
    trein: BetrokkenTrein;
};

function BusEvacutatieActions({ dossierId, trein }: BusEvacutatieActionsProps) {
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editAfgerondDialogOpen, setEditAfgerondDialogOpen] = useState(false);
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

    const { aantalBussen, afzetStation, etaAfzetStation, opstelLocatie, uitvoerder: vervoerder, status } = trein.busEvacuatie!;

    return (
        <div className="flex items-center gap-2">
            {BusEvacuatie.isCancellable(trein.busEvacuatie!) && (
                <Button variant="secondary" size="s" onClick={() => setCancelDialogOpen(true)}>
                    Intrekken evacuatiebus
                </Button>
            )}
            <ActionsDropdown>
                <DropdownMenuItem
                    onClick={() => {
                        if (status === "Afgerond") {
                            setEditAfgerondDialogOpen(true);
                        } else {
                            setEditDialogOpen(true);
                        }
                    }}
                >
                    Bestelling aanpassen
                </DropdownMenuItem>
            </ActionsDropdown>
            {editDialogOpen && (
                <BusEvacuatieNewEditDialog
                    dossierId={dossierId}
                    trein={trein}
                    open={editDialogOpen}
                    onOpenChange={setEditDialogOpen}
                    defaultValues={{ vervoerder, aantalBussen: String(aantalBussen), opstelLocatie, naarStation: afzetStation }}
                />
            )}
            {editAfgerondDialogOpen && (
                <BusEvacuatieAfronden
                    dossierId={dossierId}
                    open={editAfgerondDialogOpen}
                    onOpenChange={setEditAfgerondDialogOpen}
                    trein={trein}
                    defaultValues={{ naarStation: afzetStation, etaNaarStation: etaAfzetStation }}
                />
            )}
            <BusEvacuatieIntrekken dossierId={dossierId} trein={trein} open={cancelDialogOpen} onOpenChange={setCancelDialogOpen} />
        </div>
    );
}

export default BusEvacutatieActions;
